/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataRequestResource } from './DataRequestResource';
import {
    DataRequestResourceFromJSON,
    DataRequestResourceFromJSONTyped,
    DataRequestResourceToJSON,
    DataRequestResourceToJSONTyped,
} from './DataRequestResource';

/**
 * 
 * @export
 * @interface ChartDataRequest
 */
export interface ChartDataRequest {
    /**
     * 
     * @type {Array<DataRequestResource>}
     * @memberof ChartDataRequest
     */
    resources: Array<DataRequestResource>;
}

/**
 * Check if a given object implements the ChartDataRequest interface.
 */
export function instanceOfChartDataRequest(value: object): value is ChartDataRequest {
    if (!('resources' in value) || value['resources'] === undefined) return false;
    return true;
}

export function ChartDataRequestFromJSON(json: any): ChartDataRequest {
    return ChartDataRequestFromJSONTyped(json, false);
}

export function ChartDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'resources': ((json['resources'] as Array<any>).map(DataRequestResourceFromJSON)),
    };
}

export function ChartDataRequestToJSON(json: any): ChartDataRequest {
    return ChartDataRequestToJSONTyped(json, false);
}

export function ChartDataRequestToJSONTyped(value?: ChartDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resources': ((value['resources'] as Array<any>).map(DataRequestResourceToJSON)),
    };
}

